<!--配置首页card-->
<template>
  <Drawer
    :title="$t('home.card_config')"
    placement="right"
    class="cardconfig-container"
    :closable="false"
    :value="showModal"
    @on-close="onClose"
    width="360"
  >
    <div class="cardconfig-inner">
      <Form>
        <draggable class="dragable" v-model="tags">
          <FormItem
            :label="tag.tagName"
            v-for="(tag, index) in tags"
            :key="index"
          >
            <i-switch v-model="tag.status"></i-switch>
          </FormItem>
        </draggable>
        <div class="bg-wrapper">
          <div class="bg-title">
            <span>{{ $t('home.dashboard_title_and_background_image') }}</span>
            <span style="color: #7f7f7f">{{ bigbBcreenTitle.length }}/10</span>
          </div>
          <Input v-model="bigbBcreenTitle" :maxlength="10" />
          <div class="bg-imgBox">
            <div
              class="bg-item"
              v-for="(item, index) in imgList"
              :key="index"
              @click="changeImgbg(item.picIndex)"
            >
              <img
                :src="item.url"
                alt=""
                :class="[{ 'active-bg': backgroundIndex === item.picIndex }]"
              />
              <div
                :class="[
                  { 'active-color': backgroundIndex === item.picIndex },
                  'bg-item-name',
                ]"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
        <FormItem>
          <Button class="ok-btn" @click="handleSubmit()">{{
            $t('common.save')
          }}</Button>
        </FormItem>
      </Form>
    </div>
  </Drawer>
</template>

<script>
import api from '../../../api/home/index';
import { filterTags } from '../dataFilter';
import wcc from 'wdz-common-components';
const utils = wcc.utils;
import draggable from 'vuedraggable';
export default {
  components: {
    draggable,
  },
  props: {
    showModal: {
      require: true,
      type: Boolean,
    },
    modules: {
      require: true,
      type: Array,
    },
    backgroundIndexProp: {
      require: true,
      type: Number,
    },
    name: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      tags: [],
      allTags: [],
      backgroundIndex: '',
      imgList: [],
      bigbBcreenTitle: this.$t('common.big_screen'),
    };
  },
  computed: {
    isRoot() {
      return (
        this.$system.$state.baseInfo.isSuper &&
        !this.$system.$state.baseInfo.data.groupId
      );
    },
  },
  watch: {
    modules() {
      this.backgroundIndex = this.backgroundIndexProp;
      this.getAllTags();
    },
    showModal(nv) {
      if (nv) {
        this.tags = JSON.parse(JSON.stringify(this.allTags));
      }
    },
    name(v) {
      this.bigbBcreenTitle = v;
    },
  },
  created() {
    this.getBackgroundUrls();
  },
  methods: {
    changeImgbg(value) {
      this.backgroundIndex = value;
    },
    onClose() {
      this.$emit('on-close');
    },
    async getBackgroundUrls() {
      let res = await api.getBackgroundUrls();

      this.imgList = res.map(i => {
        if (i.picIndex === 0) {
          return {
            url: i.picUrl,
            name: this.$t('home.default'),
            picIndex: i.picIndex,
          };
        } else {
          return {
            url: i.picUrl,
            name: this.$t('home.background') + i.picIndex,
            picIndex: i.picIndex,
          };
        }
      });
    },
    async getAllTags() {
      let tags = [];
      if (this.allTags.length > 0) {
        tags = this.allTags;
      } else {
        tags = await api
          .getAllUserTags({ getNewTag: 1, getCommonTag: 1 })
          .then(res => {
            //把tagType为0的模块以极消息模块过滤掉，不展示
            return filterTags(res.data);
          })
          .catch(error => {
            this.$Message.error(this.$t('home.card_config_geterror') + error);
          });
      }
      //root账号不显示数据中心
      tags = tags.filter(item => {
        return !(item.id == -13 && this.isRoot);
      });
      this.allTags = this.filterSubscribed(tags);
    },
    //过滤已经订阅和未订阅的
    filterSubscribed(tags) {
      let orderTags = []; //给当前订阅的列表排序
      let modules = utils.deepCopy(this.modules);
      //先展示已经排序的模块
      modules.forEach(module => {
        module.status = true;
        orderTags.push(module);
      });
      //剩余未订阅的模块最后加进来
      tags.map(tag => {
        if (!modules.find(item => item.tagName === tag.tagName)) {
          tag.status = false;
          orderTags.push(tag);
        }
      });
      return orderTags;
    },
    handleSubmit() {
      let tagIds = '';
      this.tags.map((tag, index) => {
        if (tag.status) {
          if (index > 0) {
            tagIds += ',';
          }
          tagIds += tag.id;
        }
      });
      if (tagIds.length === 0) {
        this.$Message.error(this.$t('home.card_config_notnullerror'));
        return;
      }
      if (this.bigbBcreenTitle.length === 0) {
        this.$Message.error('大屏标题不能为空~');
        return;
      }
      api
        .saveUserShopTags({
          tagIds: tagIds,
          backgroundIndex:
            this.backgroundIndex === -100 ? null : this.backgroundIndex,
          name: this.bigbBcreenTitle,
        })
        .then(() => {
          this.$Message.success(this.$t('common.save_success'));
          this.$emit('refresh');
          this.onClose();
        })
        .catch(error => {
          this.$Message.success(this.$t('common.save_error'));
          console.error(error);
        });
    },
  },
};
</script>
<style lang="scss" type="text/scss">
.cardconfig-container {
  .bg-wrapper {
    border-top: 1px solid #e5e5e5;
    border-bottom: 1px solid #e5e5e5;
    .bg-title {
      display: flex;
      justify-content: space-between;
      margin: 11px 0;
      font-weight: 600;
      font-size: 13px;
      color: #333333;
    }
    .bg-imgBox {
      padding-bottom: 40px;
      margin: 11px 0 20px;
      overflow: auto;
      display: flex;
      flex-wrap: nowrap;
      /*滚动条*/
      &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: #f5f5f5;
      }
      /*定义滚动条的轨道，内阴影及圆角*/
      &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        border-radius: 6px;
        background-color: #f5f5f5;
      }
      /*定义滑块，内阴影及圆角*/
      &::-webkit-scrollbar-thumb {
        /*width: 10px;*/
        height: 20px;
        border-radius: 6px;
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        background-color: rgb(200, 200, 200);
        &:hover {
          background-color: rgb(140, 140, 140);
        }
      }
      .bg-item {
        cursor: pointer;
        width: 120px;
        height: 67.5px;
        border-radius: 8px;
        margin-right: 8px;

        img {
          width: 120px;
          height: 67.5px;
        }
        .active-bg {
          border: 2px solid #ff9900;
          border-radius: 8px;
        }
        .bg-item-name {
          text-align: center;
          font-weight: 400;
          font-size: 13px;
          color: #333333;
        }
        .active-color {
          color: #ff9900;
        }
      }
    }
  }
  .ivu-drawer-wrap {
    z-index: 9999;
  }
  .ivu-drawer-header-inner {
    font-weight: bold;
  }
  .ivu-form-item-content {
    text-align: right;
  }
  .ok-btn {
    width: 100%;
    padding: 6px 15px;
    background: $secondary-color;
    color: #fff;
    font-size: 14px;
    border: 1px solid $secondary-color;
  }
  .ok-btn:hover {
    background: $secondary-color-hover;
    color: #fff;
  }
  .ivu-switch-checked {
    background-color: $green-color;
    border-color: $green-color;
  }
}
</style>
